<template>
  <div style="width: 70%" class="pl-2">
    <h6 style="line-height: 35px;">
      TOP {{ RecordsFound }} {{ HeadingLabel }} Category Products
    </h6>
    <div class="d-flex mt-2">
      <div style="width: 50%;" class="p-2 border rounded mr-1">
        <div class="form-group">
          <label for="search">
            Search category items
          </label>
          <input
            type="text"
            v-model="SearchProductTerm"
            id="search"
            class="form-control"
          />
        </div>
        <button
          class="btn btn-primary mr-2"
          :disabled="Loading === true"
          @click="searchData"
        >
          Search
        </button>
        <button
          class="btn btn-danger"
          style="color: white;"
          :disabled="Loading === true"
          @click="clearSearchTermAndUpdate"
        >
          Clear
        </button>
      </div>

      <div style="width: 50%;" class="p-2 border rounded ml-1">
        <div class="form-group">
          <label for="rename">
            Rename category
          </label>
          <input
            type="text"
            v-model="RenamedCategory"
            id="rename"
            class="form-control"
          />
        </div>
        <button
          class="btn btn-primary"
          :disabled="sidepanelFetchingState"
          @click="RenameCategory"
        >
          Rename
        </button>
      </div>
    </div>
    <div class="form-group form-inline mt-2 mb-0" style="justify-content: end;">
      <span class="mr-1">Show </span
      ><select
        v-model="PageSize"
        :disabled="Loading === true"
        class="form-control"
        ><option :value="10">10</option
        ><option :value="15">15</option
        ><option :value="20">20</option
        ><option :value="25">25</option
        ><option :value="50">50</option
        ><option :value="100">100</option
        ><option :value="200">200</option
        ><option :value="500">500</option
        ><option :value="1000">1000</option></select
      ><span class="ml-1 mr-2"> entries</span>
    </div>
    <!-- Product Results -->
    <div v-if="Loading === true" class="p-2 rounded border mt-1 mb-3">
      <a-spin />
    </div>
    <div
      v-if="Loading === false && TotalRecords !== 0"
      class="p-2 rounded border mt-1 mb-3"
    >
      <div
        v-for="Product in getAllProductsData.Result"
        :key="Product.productsParent.productid"
        class="p-1 mb-1 card"
      >
        <div class="d-flex">
          <img
            :src="Product.productsParent.imageurl"
            alt=""
            style="height: 150px; width: 150px"
          />
          <p class="ml-2 mt-1">{{ Product.productsParent.name }}</p>
        </div>
        <div class="mt-1">
          <button
            class="btn btn-primary btn-sm"
            @click="moveProduct(Product.productsParent.productid)"
          >
            &lt; Move
          </button>
          <button
            class="ml-1 btn btn-danger btn-sm"
            @click="() => deleteProduct(Product.productsParent.productid)"
            style="color: white;"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
    <!-- /Product Results -->
    <!-- page Number -->
    <div class="d-flex mb-2" v-if="Loading === false && TotalRecords !== 0">
      <div style="flex-grow: 1;" class="pl-2">
        <p>
          Showing {{ (PageNumber - 1) * PageSize + 1 }} to
          {{ UpperLimit }}
          of {{ TotalRecords }} entries
        </p>
      </div>
      <div class="pr-2">
        <Pagination
          :data="getAllProductsData.Result"
          :totalPages="Math.ceil(TotalRecords / PageSize)"
          :total="TotalRecords"
          :perPage="PageSize"
          :currentPage="PageNumber"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
    <div
      class="border rounded p-2 mt-1"
      v-if="Loading === false && TotalRecords === 0"
    >
      No Results Found.
    </div>
    <!-- page Number -->
  </div>
</template>

<script>
import Pagination from "../../../../components/Pagination.vue";

export default {
  name: "CategoriesMainview",
  data() {
    return {
      PageSize: 10,
      SearchProductTerm: "",
      RenamedCategory: "",
      RecordsFound: 400,
    };
  },
  components: {
    Pagination,
  },
  watch: {
    PageSize() {
      this.updateData();
    },
  },
  computed: {
    getCurrentCategoryID() {
      return this.$store.getters["categories/getCurrentCategoryID"];
    },
    getCurrentCategoryHID() {
      return this.$store.getters["categories/getCurrentCategoryHID"];
    },
    getAllProductsData() {
      return this.$store.getters["categories/getAllProductsData"];
    },
    getSearchProductTerm() {
      return this.$store.getters["categories/getSearchProductTerm"];
    },
    TotalRecords() {
      return this.getAllProductsData.totalRecords;
    },
    UpperLimit() {
      return this.TotalRecords < this.PageNumber * this.PageSize
        ? this.TotalRecords
        : this.PageNumber * this.PageSize;
    },
    getRenameCategoryHID() {
      return this.$store.getters["categories/getRenameCategoryHID"];
    },
    sidepanelFetchingState() {
      return this.$store.getters["categories/sidepanelFetchingState"];
    },
    PageNumber() {
      return this.$store.state.categories.pageNumber;
    },
    HeadingLabel() {
      return this.$store.state.categories.headingLabel;
    },
    Loading() {
      return this.$store.state.categories.mainpanelFetching;
    },
    getCategoryData() {
      return this.$store.getters["categories/getCategoryData"];
    },
    currentCategoryHID() {
      return this.$store.state.categories.currentCategoryHID;
    },
  },
  methods: {
    onPageChange(page) {
      console.log("page changed", page);
      this.$store.commit("categories/SET_PAGE_NUMBER", page);
      try {
        this.updateData();
      } catch (error) {
        console.log(error);
      }
      window.scrollTo(0, 0);
    },
    RenameCategory() {
      // checks
      if (this.getRenameCategoryHID === "/") {
        alert("Please select a category and try again.");
        return;
      }
      if (this.RenamedCategory.trim() === "") {
        alert("Please enter a valid category name and try again.");
        return;
      }

      // clearing inputs
      let RenamedCategory = this.RenamedCategory;
      this.RenamedCategory = "";

      // payload + api call
      const payload = {
        categoryID: this.getCurrentCategoryID,
        label: RenamedCategory,
      };

      this.$store.commit("categories/SET_SIDEPANEL_FETCHING_STATE", true);

      // console.log(payload);
      this.$store.dispatch("categories/renameCategory", payload).then(() => {
        this.$store
          .dispatch("categories/getCategory", {
            categoryID: this.getRenameCategoryHID,
          })
          .then(() => {
            console.log(this.currentCategoryHID);
            console.log(this.getCategoryData.hid);
            console.log(this.currentCategoryHID === this.getCategoryData.hid);
            if (this.currentCategoryHID === this.getCategoryData.hid) {
              this.$store.commit(
                "categories/SET_HEADING_LABEL",
                RenamedCategory
              );
            }
            this.$store.commit(
              "categories/SET_SIDEPANEL_FETCHING_STATE",
              false
            );
          });
      });
    },
    clearSearchTermAndUpdate() {
      this.SearchProductTerm = "";
      this.$store.commit("categories/SET_HEADING_LABEL", "");
      this.$store.commit("categories/SET_PRODUCT_SEARCH_TERM", "");
      this.$store.commit("categories/SET_CURRENT_CATEGORY_HID", "/");
      this.updateData();
    },
    searchData() {
      this.$store.commit("categories/SET_PAGE_NUMBER", 1);
      this.$store.commit(
        "categories/SET_PRODUCT_SEARCH_TERM",
        this.SearchProductTerm
      );
      this.updateData();
    },
    updateData() {
      this.$store.commit("categories/SET_MAINPANEL_FETCHING_STATE", true);
      this.RecordsFound = null;
      this.$store
        .dispatch("categories/getAllProducts", {
          pageNumber: this.PageNumber,
          pageSize: this.PageSize,
          sortField: "",
          sortOrder: "",
          prodName: this.getSearchProductTerm,
          supplierID: null,
          includeDeletedProducts: false,
          excludeDynamicVendor: false,
          skuProductNumber: "",
          categoryID: "",
          subCatID1: this.getCurrentCategoryHID,
          subCatID2: "",
        })
        .then((data) => {
          this.RecordsFound = data.totalRecords;
          this.$store.commit("categories/SET_MAINPANEL_FETCHING_STATE", false);
        });
    },
    moveProduct(ProductID) {
      if (this.getCurrentCategoryID === 1) {
        alert("Please select a category and then try again.");
        return;
      }
      this.$store
        .dispatch("categories/moveProductToCategory", {
          productID: ProductID,
          categoryID: this.getCurrentCategoryID,
        })
        .then(() => {
          this.updateData();
        });
    },
    deleteProduct(ProductID) {
      let confirmation = confirm(
        "Are you sure you want to delete this product?"
      );
      if (!confirmation) {
        return;
      }
      this.$store
        .dispatch("categories/deleteProductByID", {
          productID: ProductID,
        })
        .then(() => {
          this.updateData();
        });
    },
  },
  created() {
    this.updateData();
  },
  destroyed() {
    this.clearSearchTermAndUpdate();
  },
};
</script>

<style>
.card:nth-child(2n) {
  background-color: #ddd;
}
</style>
